type TableProps = {
  rows: Record<string, string>[]
}

const Table = (props: TableProps): JSX.Element => {
  const generateRow = (row: Record<string, string>, index: number): JSX.Element => {
    const [key, value] = Object.entries(row)[0]

    return (
      <div className="flex-auto flex-col w-1/2" key={index}>
        <b className="cell">{key}</b>
        <div className="cell">{value}</div>
      </div>
    )
  }

  return <div className="top-separator flex">{props.rows.map((row, index) => generateRow(row, index))}</div>
}

export default Table
